<template>
  <section>
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('HUB', 2) }) | formatTitle"></vue-headful>
    <hub-list></hub-list>

    <article class="hubs__route">
      <router-view></router-view>
    </article>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
article.hubs__route {
  height: 100%;
}
</style>

<script>
// @flow
import HubList from './HubList'

export default {
  name: 'hubs',
  components: { HubList }
}
</script>
